export const CHART_VARIANTS = Object.freeze({
  column: 'column',
  pie: 'pie',
  line: 'line',
} as const);

export type ChartTypes = (typeof CHART_VARIANTS)[keyof typeof CHART_VARIANTS];
